import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

@Component({
    template: `<div>This component requires extending</div>`,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class AuthTypeComponent {
    @Input() public modalData: State.IModal = null;

    constructor(
        public controllers: Controllers,
    ) { }
}
